import React from "react";
import "./Practices.css";
import { motion } from "framer-motion";
import qcnews from "../assets/img32.jpg";
import tqmchart from "../assets/img33a.jpg";
import tqmimg from "../assets/tqm-img-notrainer.png";
import Footer from "./Footer";

export default function TQMPractices() {
  return (
    <section id="practices">
      <motion.div
        className="tqm-container"
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 1 }}
        viewport={{ once: false, amount: 0.2 }}
      >
        {/* 🔹 Title */}
        <motion.h1
          className="tqm-title-main"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
        >
          Total Quality Management (TQM)
        </motion.h1>

        {/* 🔹 Underline */}
        <motion.div
          className="prac-underline"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />

        {/* --- SECTION 1 --- */}
        <motion.div
          className="tqm-section"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.2 }}
        >

          {/* IMAGE */}
          <motion.div
            className="tqm-images"
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <motion.img
              src={tqmchart}
              alt="QC News"
              whileHover={{
                scale: 1.08,
                boxShadow: "0px 10px 25px rgba(0, 82, 180, 0.3)",
              }}
              transition={{ type: "spring", stiffness: 180 }}
            />
          </motion.div>
          {/* TEXT */}
          <motion.div
            className="tqm-text"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <h3>Driving Excellence, Casting the Future</h3>

            <p>
              Sundaram Clayton Ltd. (SCL) began its TQM journey in{" "}
              <span style={{ color: "#0052B4", fontWeight: "bold" }}>
                1985
              </span>
              , building a culture of continuous improvement, employee involvement,
              and process excellence. With{" "}
              <span style={{ color: "#0052B4", fontWeight: "bold" }}>
                QCCs
              </span>
              , the TEIAN idea system, and guidance from Japanese experts, SCL
              strengthened Daily Management, Policy Deployment and Cross-Functional
              Management.
            </p>

            <p>
              This commitment earned global acclaim —{" "}
              <span style={{ color: "#0052B4", fontWeight: "bold" }}>
                Deming Prize (1998)
              </span>{" "}
              and{" "}
              <span style={{ color: "#0052B4", fontWeight: "bold" }}>
                Japan Quality Medal (2002)
              </span>
              . TPM, Lean practices and disciplined PDCA/SDCA cycles continue to
              drive performance, enabling{" "}
              <span style={{ color: "#0052B4", fontWeight: "bold" }}>
                100% employee participation
              </span>{" "}
              in improvement activities for over 25 years.
            </p>

            <h4>The SCL Way of Thinking</h4>
            <div className="tqm-points">
              <span>&#160;&#160;Customer Focus</span>
              <span>Quality First</span>
              <span>Fact Control</span>
              <span>Recurrence Prevention</span>

              <span>PDCA Cycle</span>
              <span>SDCA Cycle</span>
              <span>Respect for People</span>
              <span>Focus on Process for Results</span>
            </div>


          </motion.div>


        </motion.div>

        {/* --- SECTION 2 --- */}
        <motion.div
          className="tqm-section"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.2 }}
        >
          {/* TEXT */}
          <motion.div
            className="tqm-text"
            initial={{ opacity: 0, x: -80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.3 }}
          >
            <h3>Workmen Skill Development</h3>

            <p>
              SCL builds a skilled, safety-conscious workforce through a structured development program that strengthens attitude, knowledge, and technical capability for world-class manufacturing, with a clear focus on strong work ethics, zero accidents, zero defects, machine ownership, and multi-process capability.
            </p>
            <h4>Skill Development Framework</h4>
            <ul>
              <li><span className="blue">Fundamental Knowledge:</span> Safety, process basics, quality systems, Kaizen, TPM</li>
              <li><span className="blue">Fundamental Skills:</span> Coordination, visual checks, safety drills, measurement</li>
              <li><span className="blue">Element Work:</span> Stepwise learning of operations</li>
              <li><span className="blue">Standardized Work:</span> Safe, defect-free operations within TAKT time</li>
            </ul>

          </motion.div>

          {/* IMAGE */}
          <motion.div
            className="tqm-images"
            initial={{ opacity: 0, x: 80 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 1, delay: 0.4 }}
          >
            <motion.img
              src={qcnews}
              alt="TQM Model"
              whileHover={{
                scale: 1.08,
                boxShadow: "0px 10px 25px rgba(0, 82, 180, 0.3)",
              }}
              transition={{ type: "spring", stiffness: 180 }}
            />
          </motion.div>
        </motion.div>

        <motion.div
          className="tqm-section reverse"
          initial={{ opacity: 0, y: 60 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 1 }}
          viewport={{ once: false, amount: 0.2 }}
        >
          {/* ===== PYRAMID + CONTENT SECTION ===== */}
          <motion.div
            className="trainer-wrapper"
            initial={{ opacity: 0, y: 60 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
            viewport={{ once: false, amount: 0.2 }}
          >
            {/* LEFT – PYRAMID */}
            <div className="pyramid-section">
              <img src={tqmimg} alt="TQM Pyramid" className="pyramid-img" />
            </div>

            {/* RIGHT – CONTENT BOXES */}
            <div className="pyramid-content">
              <div className="content-box">
                <h4>Standardized Work</h4>
                <p>Safe defect free working with in tact time</p>
                <p>On the job training (shop floor)</p>
              </div>

              <div className="content-box">
                <h4>Element Work</h4>
                <p>Step by Step training on manual element of work</p>
                <p>On the job training (shop floor)</p>
              </div>

              <div className="content-box">
                <h4>Fundamental Skill</h4>
                <p>
                  Step by Step training provided on the activity to make them acquire
                  the skill
                </p>
                <p>SDC + On the job training (shop floor)</p>
              </div>

              <div className="content-box">
                <h4>Fundamental Knowledge</h4>
                <p>
                  Basic training provided on the topics to make them understand the
                  concepts
                </p>
                <p>Theory (Class room training) + video module training</p>
              </div>
            </div>
          </motion.div>
        </motion.div>

        <h3>Training Approach</h3>
        <p>PDCA-driven: Identify gaps → create modules → classroom/video/OJT → certification → periodic reviews. </p>
        <h3>Process Capability Building</h3>
        <p>Training covers all key areas of casting and machining, including GDC, PDC, fettling, heat treatment, CNC machining, washing, leak testing, gauging, inspection and basic maintenance.</p>
        <p style={{ margin: "10px 0 50px 0" }}>Through structured learning, certified skill levels and continuous evaluation, SCL empowers every workman to deliver quality, safety and operational excellence — making TQM a way of life by ensuring customer satisfaction.</p>
      </motion.div>

      <Footer />
    </section>
  );
}
